import React from 'react'
import Asset from './Asset'
import ProgressBar from './ProgressBar'
import StarOn from 'shared/components/Icons/star_on.png'

interface Upload {
  id: string
  asset: any
  isUploading: boolean
  shouldUpload: boolean
  progress: number | null
}

interface Props {
  uploaders: Upload[]
  className?: string
  draggable?: boolean
  preDefinedLabels?: any[]
  onClickPrimaryUpload?: (upload: Upload) => void
  onClickAdditionalUpload?: (upload: Upload) => void
  children?: any
  [key: string]: any
}

function AssetDeliveryGroup({
  uploaders,
  className,
  preDefinedLabels = [],
  onClickPrimaryUpload,
  onClickAdditionalUpload,
  children = null,
  ...rest
}: Props) {
  const primaryUpload = uploaders.find(u => u.asset.masterForGroupId) || uploaders[0]
  const additionalUploads = uploaders
    .filter(u => u.id !== primaryUpload.id)
    .map(u => ({...u, asset: {...u.asset, labels: undefined}}))

  const classNames = ['asset-delivery-group']
  if (className) classNames.push(className)

  return (
    <div
      tabIndex={0}
      className={classNames.join(' ')}
      {...rest}
    >
      <div className="group-additional-assets">
        {additionalUploads.map((upload) => (
          <Asset
            key={upload.id}
            uploader={upload}
            onClick={() => onClickAdditionalUpload && onClickAdditionalUpload(upload)}
          />
        ))}
      </div>

      <div className="group-primary-asset">
        {!!primaryUpload && (
          <Asset
            uploader={primaryUpload}
            preDefinedLabels={preDefinedLabels}
            onClick={() => onClickPrimaryUpload && onClickPrimaryUpload(primaryUpload)}
          />
        )}
      </div>

      {primaryUpload?.asset.isPrimary && (
        <div className="starred">
          <img src={StarOn} alt="" />
        </div>
      )}

      {children}

      <div className="file-upload-progress">
        {[primaryUpload, ...additionalUploads]
          .filter(upload => !!upload && (upload.isUploading || upload.shouldUpload) && upload.progress !== 100)
          .map((upload) => (
            <ProgressBar
              key={upload.id}
              progress={upload.progress}
            />
          )
        )}
      </div>
    </div>
  )
}

export default AssetDeliveryGroup
